<template>
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.34001 14.5036L4.50129 17.6223L1.43578 17.6869C0.519648 15.9944 0 14.0579 0 12.0001C0 10.0102 0.485858 8.13374 1.34707 6.48145H1.34773L4.0769 6.97982L5.27243 9.68188C5.02221 10.4085 4.88583 11.1885 4.88583 12.0001C4.88592 12.881 5.04612 13.725 5.34001 14.5036Z" fill="#FBBB00"/>
<path d="M23.8848 9.75781C24.0231 10.4837 24.0953 11.2334 24.0953 11.9996C24.0953 12.8587 24.0046 13.6967 23.8318 14.5051C23.2453 17.2558 21.7129 19.6578 19.59 21.3576L19.5894 21.3569L16.1518 21.1822L15.6653 18.1572C17.0739 17.3343 18.1748 16.0466 18.7547 14.5051H12.3125V9.75781H18.8487H23.8848Z" fill="#518EF8"/>
<path d="M19.589 21.3577L19.5897 21.3584C17.5251 23.0113 14.9024 24.0004 12.0474 24.0004C7.45936 24.0004 3.47042 21.4461 1.43555 17.6872L5.33978 14.5039C6.35719 17.2085 8.97656 19.1338 12.0474 19.1338C13.3673 19.1338 14.6039 18.7784 15.665 18.158L19.589 21.3577Z" fill="#28B446"/>
<path d="M19.7382 2.76262L15.8352 5.94525C14.7371 5.26153 13.4389 4.86656 12.0482 4.86656C8.90787 4.86656 6.23951 6.88017 5.27306 9.68175L1.34832 6.48131H1.34766C3.35274 2.63077 7.39198 0 12.0482 0C14.9714 0 17.6517 1.03716 19.7382 2.76262Z" fill="#F14336"/>
</svg>


</template>

<script>
export default {

}
</script>

<style>

</style>